import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { ReportType } from '../types';

interface Props {
  value: ReportType;
  onChange: (value: ReportType) => void;
}

export const ReportTypeCard: React.FC<Props> = ({ value, onChange }) => {
  const { tokens } = useTheme<LensTheme>();
  const color = tokens.semantic.color;
  return (
    <Box
      data-testid="report-type-card"
      sx={{
        border: `1px solid ${color.ui.divider.default.value}`,
        borderRadius: tokens.semantic.radius.md.value,
        padding: tokens.semantic.spacing.desktop.gap[2].value,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography
        sx={{
          fontWeight: tokens.semantic.fontWeight.emphasis.value,
          fontSize: '16px',
        }}
      >
        Report type
      </Typography>
      <Typography sx={{ fontSize: '12px', color: color.type.muted.value }}>
        Select Misconduct report for code of conduct issues that follow the full
        reporting process or Inquiry for non-code-of-conduct topics.
      </Typography>
      <RadioGroup
        value={value}
        onChange={(_e, v) => onChange(v as ReportType)}
        sx={{ gap: '8px' }}
      >
        <FormControlLabel
          value="misconduct"
          control={<Radio data-testid="report-type-misconduct" />}
          label="Misconduct report"
        />
        <FormControlLabel
          value="inquiry"
          control={<Radio data-testid="report-type-inquiry" />}
          label="Inquiry"
        />
      </RadioGroup>
    </Box>
  );
};
